import MuiClickAwayListener from '@mui/material/ClickAwayListener';

function SafeClickAwayListener({ children, onClickAway, mouseEvent, touchEvent, disableReactTree }) {
	return (
		<MuiClickAwayListener onClickAway={onClickAway} mouseEvent={mouseEvent} touchEvent={touchEvent} disableReactTree={disableReactTree}>
			{children}
		</MuiClickAwayListener>
	);
}

export default SafeClickAwayListener;
